/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum SchedulingResponseStatus {
  Success = 0,
  Failure = 1,
  Error = 2,
  Warning = 3,
  Await = 4,
}
